import React from "react";
import { useParams } from 'react-router-dom';

import ListPermissions from './ListPermissions'
import List from './List'

const Component = () => {
    const { _id } = useParams()
    return (
        <>
            <ListPermissions>
                <List earningSettingId={_id} />
            </ListPermissions>
        </>
    );
};

export default Component;
